<template>
  <b-form
    @submit.stop.prevent="handleSubmit"
    class="text-left"
  >
    <b-form-group
      :label="fieldLabels.service_id"
      label-for="commission-service_id"
    >
      <service-select
        :select-class="{ 'is-invalid': $v.form.service_id.$dirty && $v.form.service_id.$error }"
        name="commission-service_id"
        :value="form.service"
        @input="onServiceChange"
      />
      <b-form-invalid-feedback
        v-if="$v.form.service_id.$dirty"
        class="commission-service_id-feedback"
      >
        <span v-if="!$v.form.service_id.required">Please enter a service.</span>
        <span v-if="!$v.form.service_id.serverFailed">{{ serverErrors.service_id }}</span>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="fieldLabels.start_date"
      label-for="commission-start_date"
    >
      <sfs-date-picker
        name="commission-start_date"
        v-model="$v.form.start_date.$model"
        :class="{ 'is-invalid': $v.form.start_date.$dirty && $v.form.start_date.$error }"
        :with-class="{ 'is-invalid': $v.form.start_date.$dirty && $v.form.start_date.$error }"
      />
      <b-form-invalid-feedback
        v-if="$v.form.start_date.$dirty"
        :state="$v.form.start_date.$dirty ? !$v.form.start_date.$error : null"
        class="commission-start_date-feedback"
      >
        <span v-if="!$v.form.start_date.serverFailed">
          {{ serverErrors.start_date }}
        </span>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="fieldLabels.commission_plan_id"
      label-for="commission-commission_plan_id"
    >
      <commission-plan-select
        :select-class="{ 'is-invalid': $v.form.commission_plan_id.$dirty && $v.form.commission_plan_id.$error }"
        select-label="name"
        name="commission-commission_plan_id"
        :value="form.commission_plan"
        @input="onCommissionPlanChange"
      />
      <b-form-invalid-feedback
        v-if="$v.form.commission_plan_id.$dirty"
        class="commission-commission_plan_id-feedback"
      >
        <span v-if="!$v.form.commission_plan_id.required">Please enter an assigned technician.</span>
        <span v-if="!$v.form.commission_plan_id.serverFailed">{{ serverErrors.commission_plan_id }}</span>
      </b-form-invalid-feedback>
    </b-form-group>

    <hr class="mt-4">

    <b-row>
      <b-col
        offset-lg="6"
        lg="3"
        order="2"
        order-lg="1"
      >
        <b-button
          variant="link-dark"
          block
          class="commission-close-button"
          @click="$emit('on-cancel')"
        >
          Cancel
        </b-button>
      </b-col>
      <b-col
        lg="3"
        order="1"
        order-lg="2"
      >
        <b-button
          class="commission-submit-button"
          block
          type="submit"
          variant="primary"
          :disabled="processing"
        >
          Save
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/formMixin';
import ServiceSelect from '@/components/admin/services/Select.vue';
import CommissionPlanSelect from '@/components/admin/commissionPlans/Select.vue';

export default {
  name: 'CommissionsForm',
  components: {
    ServiceSelect,
    CommissionPlanSelect,
  },
  mixins: [formMixin],
  props: {
    start_date: String,
    location_id: [String, Number],
    service_id: [String, Number],
    commission_plan_id: [String, Number],
    location: Object,
    service: Object,
    commission_plan: Object,
  },
  data() {
    return {
      form: {
        start_date: this.start_date,
        location_id: this.location_id,
        service_id: this.service_id,
        commission_plan_id: this.commission_plan_id,
        location: this.location,
        service: this.service,
        commission_plan: this.commission_plan,
      },
      fieldLabels: {
        start_date: 'Start Date',
        location_id: 'Location',
        service_id: 'Service',
        commission_plan_id: 'Commission Plan',
      },
    };
  },
  validations: {
    form: {
      start_date: {
        serverFailed() {
          return !this.hasServerErrors('start_date');
        },
      },
      location_id: {
        required,
        serverFailed() {
          return !this.hasServerErrors('location_id');
        },
      },
      service_id: {
        required,
        serverFailed() {
          return !this.hasServerErrors('service_id');
        },
      },
      commission_plan_id: {
        required,
        serverFailed() {
          return !this.hasServerErrors('commission_plan_id');
        },
      },
    },
  },
  methods: {
    onServiceChange(service) {
      this.form.service_id = service ? service.id : '';
      this.form.service = service;
    },
    onCommissionPlanChange(plan) {
      this.form.commission_plan_id = plan ? plan.id : null;
      this.form.commission_plan = plan;
    },
  },
};
</script>
